import React from "react";
import { Layout } from "antd";
import "./loaderStyle.scss";
import TopHeader from "../header/Header";
import { LoadingOutlined } from "@ant-design/icons";

const FallBackLoading = () => (
  <Layout
    className="ant-layout-content"
    style={{ margin: "24px 16px"}}
  >
    <TopHeader
      isTitle={true}
      isRightContent={false}
      title="....."
      icon={<LoadingOutlined className="icon-size text-white" />}
    />
  </Layout>
);

export default FallBackLoading;
